<template>
  <v-dialog v-model="editDialog" class="the-app-dialogs" persistent max-width="800px">
    <v-card>
      <form @submit.prevent="validateBeforeSubmit($event)">
        <v-layout row class="no-select" style="background-color:#09132f">
          <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
            <v-layout align-center>
              <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">attach_money</v-icon>
              <span class="px-3">{{ $t('Edit Remittance Office information') }}</span>
            </v-layout>
          </h3>
          <v-spacer />
          <v-card-actions>
            <v-btn fab icon dark @click="$emit('hidemodal')">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-actions>
        </v-layout>

        <v-card-title class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="headline no-select pb-1">
              <v-layout justify-end></v-layout>
            </v-flex>

            <v-layout row wrap>
              <v-flex xs12 sm12 md12 class="py-1 px-2">
                <v-text-field
                  v-model="remittanceOfficeInfo.remittance_office_name"
                  :label="`${$t('Name')} *`"
                  name="remittance_office_name"
                  hide-details
                  box
                  background-color="white"
                  data-vv-name="Name"
                  :error="errors.has('Name')"
                  v-validate="'required'"
                />
              </v-flex>
              <v-flex xs6 sm6 md6 pa-2>
                <v-text-field
                  v-model="remittanceOfficeInfo.remittance_office_phone"
                  :label="$t('Phone Number')"
                  name="remittance_office_phone"
                  hide-details
                  box
                  background-color="white"
                />
              </v-flex>

              <v-flex xs6 sm6 md6 pa-2>
                <v-text-field
                  v-model="remittanceOfficeInfo.remittance_office_mail"
                  :label="$t('Email')"
                  name="remittance_office_mail"
                  data-vv-name="Email"
                  hide-details
                  box
                  background-color="white"
                  :error="errors.has('Email')"
                  v-validate="'email'"
                />
              </v-flex>
              <v-flex xs6 sm6 md6 pa-2>
                <v-text-field
                  v-model="remittanceOfficeInfo.remittance_office_address"
                  :label="$t('Address')"
                  name="remittance_office_address"
                  hide-details
                  box
                  background-color="white"
                />
              </v-flex>

              <v-flex xs6 sm6 md6 pa-2>
                <v-autocomplete
                  :items="this.$vuetify.rtl ? fullCountriesListAr : fullCountriesListEn"
                  v-model="remittanceOfficeInfo.remittance_office_country"
                  :label="$t('Country')"
                  box
                  name="remittance_office_country"
                  hide-details
                  data-vv-name="Country"
                  :menu-props="{ transition: 'slide-y-transition' }"
                  background-color="white"
                />
              </v-flex>
              <v-flex xs6 sm6 md6 pa-2>
                <v-text-field
                  v-model="remittanceOfficeInfo.remittance_office_governorate"
                  :label="$t('Governorate')"
                  name="remittance_office_governorate"
                  hide-details
                  box
                  background-color="white"
                />
              </v-flex>

              <v-flex xs6 sm6 md6 pa-2>
                <v-text-field
                  v-model="remittanceOfficeInfo.remittance_office_city"
                  :label="$t('City')"
                  name="remittance_office_city"
                  hide-details
                  box
                  background-color="white"
                />
              </v-flex>
            </v-layout>
          </v-layout>
        </v-card-title>
        <v-divider light />

        <v-card-actions class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="pb-2 px-2" style="color: #444;"
              >- {{ $t('Fields marked with asterisk ( * ) are required.') }}</v-flex
            >

            <v-layout justify-end>
              <v-btn outline color="primary" @click="$emit('hidemodal')">{{ $t('Cancel') }}</v-btn>
              <v-btn type="submit" color="success" :loading="btnUpdateLoading">
                <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">save</v-icon>
                {{ $t('Update') }}
              </v-btn>
            </v-layout>
          </v-layout>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'edit-component',

  props: {
    editDialog: { type: Boolean, required: true }
  },

  data() {
    return {
      btnUpdateLoading: false
    }
  },

  computed: {
    ...mapGetters({
      remittanceOfficeInfo: 'remittances/getRemittanceOfficeInfo',
      fullCountriesListEn: 'countries/getFullCountriesListEn',
      fullCountriesListAr: 'countries/getFullCountriesListAr'
    })
  },

  watch: {
    editDialog: {
      immediate: false,
      handler() {
        if (this.editDialog) {
          this.addEscKeyListener()
        }
      }
    }
  },

  methods: {
    ...mapActions({
      updateRemittanceOfficeInfo: 'remittances/updateRemittanceOfficeInfo'
    }),

    addEscKeyListener() {
      document.addEventListener('keyup', e => {
        // if the 'ESC' button was pressed and this dialog is shown, hide it
        if (e.keyCode === 27 && this.editDialog) {
          this.$emit('hidemodal')
        }
      })
    },

    validateBeforeSubmit(event) {
      this.$validator
        .validateAll()
        .then(() => {
          if (!this.errors.any()) {
            this.btnUpdateLoading = true
            let formData = new FormData(event.target)
            if (this.remittanceOfficeInfo.remittance_office_country) {
              formData.append('remittance_office_country', this.remittanceOfficeInfo.remittance_office_country)
            } else {
              formData.append('remittance_office_country', '')
            }

            let payload = {
              id: this.remittanceOfficeInfo.remittance_office_id,
              formData
            }
            this.updateRemittanceOfficeInfo(payload)
              .then(() => {
                this.btnUpdateLoading = false
                this.$emit('updated')
              })
              .catch(() => {
                this.btnUpdateLoading = false
              })
          }
        })
        .catch(() => {
          this.btnUpdateLoading = false
        })
    }
  }
}
</script>

<style scoped />
